module.exports = __webpack_public_path__ + "img/2.a143240b.png";